import React from 'react';
import { getBeneficiaryIcon } from '../BeneficiaryMainCard';
import BeneficiarySection from '../BeneficiarySection';
import BeneficiarySingleValue from '../BeneficiaryValues/BeneficiarySingleValue';
import { MainCategoryProps } from '../MainCategory';
import {
  Beneficiaries,
  BeneficiaryTitleInfoProps,
} from '../utils/beneficiaryInterfaces';
import { beneficiaryTitle } from '../utils/helperComponents';

const minWidth = 256;

interface BeneficiaryHealthProps extends BeneficiaryTitleInfoProps {
  beneficiary: Beneficiaries['health'];
  setBeneficiaries: MainCategoryProps['setBeneficiaries'];
}

const BeneficiaryHealth: React.FC<BeneficiaryHealthProps> = ({
  beneficiary,
  beneficiaryLabel,
  programName,
  setBeneficiaries,
}) => {
  if (beneficiary === undefined) return null;
  return (
    <BeneficiarySection
      icon={getBeneficiaryIcon('health')}
      setBeneficiaries={setBeneficiaries}
      category="health"
      heading="Health"
      title={beneficiaryTitle(
        'the Health groups',
        programName,
        beneficiaryLabel,
      )}
      note={undefined}
    >
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="People with disabilities"
        buttonLabel="People with disabilities"
        inputLabel="People with disabilities"
        categoryName="health"
        category={beneficiary.categories}
        fieldName="People with disabilities"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="People with diseases and illnesses"
        buttonLabel="People with diseases and illnesses"
        inputLabel="People with diseases and illnesses"
        categoryName="health"
        category={beneficiary.categories}
        fieldName="People with diseases and illnesses"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="People with substance use disorder"
        buttonLabel="People with substance use disorder"
        inputLabel="People with substance use disorder"
        categoryName="health"
        category={beneficiary.categories}
        fieldName="Substance abusers"
        setBeneficiaries={setBeneficiaries}
      />
    </BeneficiarySection>
  );
};

export default React.memo(BeneficiaryHealth);
